import React from 'react';
import {
    Box,
    Typography,
    Chip,
    Button,
    Tooltip
} from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import DownloadIcon from '@mui/icons-material/Download';
import RefreshIcon from '@mui/icons-material/Refresh';
import UploadIcon from '@mui/icons-material/Upload';
import CloudSyncIcon from '@mui/icons-material/CloudSync';

const FreteGratisHeader = ({ 
    totalCount, 
    loading, 
    onRefresh, 
    onExport,
    onImport,
    onImportFromML,
    exportStatus = 'idle',
    importFromMLLoading = false
}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                justifyContent: 'space-between',
                alignItems: { xs: 'flex-start', md: 'center' },
                mb: 3,
                pb: 3,
                borderBottom: '2px solid #f5f5f5'
            }}
        >
            <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <LocalShippingIcon sx={{ color: '#ff9800', fontSize: 32 }} />
                    <Typography variant="h4" sx={{ fontWeight: 700, color: '#333' }}>
                        Frete Grátis
                    </Typography>

                    <Chip
                        label={loading ? "Carregando..." : `${totalCount || 0} registros`}
                        size="medium"
                        sx={{
                            bgcolor: '#f8f9fa',
                            color: '#495057',
                            fontWeight: 600,
                            fontSize: '0.875rem',
                            height: 28,
                            border: '1px solid #e9ecef'
                        }}
                    />
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.8, gap: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                        Consulte os custos de frete dos seus produtos do Mercado Livre
                    </Typography>
                </Box>
            </Box>

            <Box sx={{ 
                mt: { xs: 3, md: 0 }, 
                display: 'flex', 
                gap: 2,
                flexDirection: { xs: 'column', sm: 'row' },
                alignItems: { xs: 'stretch', sm: 'center' }
            }}>
                <Button
                    variant="outlined"
                    startIcon={<RefreshIcon />}
                    onClick={onRefresh}
                    disabled={loading}
                    sx={{
                        borderColor: '#dee2e6',
                        color: '#495057',
                        bgcolor: 'white',
                        fontWeight: 500,
                        px: 3,
                        py: 1,
                        '&:hover': {
                            borderColor: '#adb5bd',
                            bgcolor: '#f8f9fa'
                        }
                    }}
                >
                    Atualizar
                </Button>

                <Button
                    variant="contained"
                    startIcon={<CloudSyncIcon />}
                    onClick={onImportFromML}
                    disabled={importFromMLLoading}
                    sx={{
                        bgcolor: "#0066cc",
                        color: "white",
                        fontWeight: 600,
                        px: 3,
                        py: 1,
                        boxShadow: '0 2px 4px rgba(0, 102, 204, 0.2)',
                        "&:hover": { 
                            bgcolor: "#0056b3",
                            boxShadow: '0 4px 8px rgba(0, 102, 204, 0.3)'
                        }
                    }}
                >
                    {importFromMLLoading ? 'Importando...' : 'Sincronizar ML'}
                </Button>

                <Button
                    variant="contained"
                    startIcon={<UploadIcon />}
                    onClick={onImport}
                    sx={{
                        bgcolor: "#198754",
                        color: "white",
                        fontWeight: 600,
                        px: 3,
                        py: 1,
                        boxShadow: '0 2px 4px rgba(25, 135, 84, 0.2)',
                        "&:hover": { 
                            bgcolor: "#157347",
                            boxShadow: '0 4px 8px rgba(25, 135, 84, 0.3)'
                        }
                    }}
                >
                    Importar Planilha
                </Button>

                <Button
                    variant="contained"
                    startIcon={<DownloadIcon />}
                    onClick={onExport}
                    disabled={exportStatus === 'processing'}
                    sx={{
                        bgcolor: "#ff9800",
                        color: "white",
                        fontWeight: 600,
                        px: 3,
                        py: 1,
                        boxShadow: '0 2px 4px rgba(255, 152, 0, 0.2)',
                        "&:hover": { 
                            bgcolor: "#f57c00",
                            boxShadow: '0 4px 8px rgba(255, 152, 0, 0.3)'
                        }
                    }}
                >
                    {exportStatus === 'processing' ? 'Processando...' : 'Exportar'}
                </Button>
            </Box>
        </Box>
    );
};

export default FreteGratisHeader;